import { CognitoAuthService } from '../infra/cognito/cognito-auth.service';

export const authService = new CognitoAuthService();
